export default {"src":"/_next/static/media/leave-record-icon.51ad0039.svg","height":14,"width":14};